"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSRBFailedSchema = exports.DSRBSchema = exports.DSRBBaseSchema = void 0;
// Meant to store when and how the DSRBs where updated, generated, etc.
var z = __importStar(require("zod"));
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
exports.DSRBBaseSchema = z.object({
    NCapUserId: z.string(),
    UserId: z.instanceof(ObjectId_1.ObjectId),
});
exports.DSRBSchema = exports.DSRBBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.DSRBFailedSchema = z.object({
    UserId: z.instanceof(ObjectId_1.ObjectId),
    Message: z.string(),
});
var DSRBFailedBaseSchema = exports.DSRBFailedSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
//# sourceMappingURL=DSRB.js.map